export enum FilterVariant {
  Default = 'default',
  Table = 'table',
}

export type FilterProps = {
  /** The filter label displayed on the left section */
  label: string;
  /** The filter value displayed on the right section. When empty, shows Default/Inactive state. */
  value?: string;
  count?: number;
  countTooltip?: string;
  /** Whether the close button is visible. Defaults to true. */
  removable?: boolean;
  /** Whether the component uses the inactive (grey) color scheme. Defaults to false. */
  inactive?: boolean;
  disabled?: boolean;
  /** Override the max width of the value text. Defaults to 110px. */
  valueMaxWidth?: string;
  testId?: string;
  variant?: FilterVariant;
};
